module.exports = __webpack_public_path__ + "img/autospin_btn.45574a23.png";